<template>
  <nav class="bottom-nav md:hidden" aria-label="Mobile navigation">
    <router-link
      v-for="item in visibleItems"
      :key="item.to"
      :to="item.to"
      class="nav-item"
      active-class="is-active"
    >
      <span class="nav-icon">
        <i :class="item.icon"></i>
      </span>
      <span>{{ item.name }}</span>
    </router-link>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      userType: "",
      items: [
        {
          name: "Home",
          to: "/dashboard",
          icon: "las la-home",
          showto: "",
        },
        {
          name: "Facilities",
          to: "/facility-management",
          icon: "las la-clinic-medical",
          showto: "staff",
        },
        {
          name: "HRH",
          to: "/personnel-management",
          icon: "las la-user-nurse",
          showto: "staff",
        },
        {
          name: "M&E",
          to: "/all-inspections",
          icon: "las la-notes-medical",
          showto: "",
        },
        {
          name: "Procure",
          to: "/procurement-item",
          icon: "las la-box",
          showto: "",
        },
      ],
    };
  },
  computed: {
    visibleItems() {
      return this.items.filter((item) => !item.showto || item.showto === this.userType);
    },
  },
  created() {
    this.userType = localStorage.getItem("type");
  },
};
</script>


<style scoped>
.bottom-nav {
  display: flex;
  position: fixed;
  left: 0.5rem;
  right: 0.5rem;
  bottom: 0.65rem;
  z-index: 50;
  align-items: center;
  justify-content: space-around;
  border-radius: 1.25rem;
  background: rgba(15, 23, 42, 0.92);
  -webkit-backdrop-filter: blur(14px);
  backdrop-filter: blur(14px);
  padding: 0.55rem 0.4rem calc(0.55rem + env(safe-area-inset-bottom));
  color: #94a3b8;
  box-shadow: 0 -4px 8px rgba(15, 23, 42, 0.05), 0 16px 32px -12px rgba(15, 23, 42, 0.45);
}

.nav-item {
  display: flex;
  min-width: 60px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  border-radius: 0.9rem;
  padding: 0.35rem 0.4rem;
  font-size: 10.5px;
  font-weight: 600;
  color: #94a3b8;
  transition: all 0.2s ease;
}

.nav-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 0.75rem;
  font-size: 1.1rem;
  background: transparent;
  transition: all 0.2s ease;
}

.nav-item.is-active {
  color: #fff;
}

.nav-item.is-active .nav-icon {
  background: linear-gradient(135deg, #00a195 0%, #0891b2 100%);
  box-shadow: 0 6px 16px -4px rgba(0, 161, 149, 0.6);
  color: #fff;
}

@media (min-width: 768px) {
  .bottom-nav {
    display: none !important;
  }
}
</style>
